import { create } from "zustand";
import { Email } from "./emailStore";

interface ContextMenuPosition {
  x: number;
  y: number;
}

interface ContextMenuState {
  isOpen: boolean;
  position: ContextMenuPosition;
  targetEmail: Email | null;
  selectedEmails: Email[];
  openMenu: (pos: ContextMenuPosition, targetEmail: Email, selectedEmails?: Email[]) => void;
  closeMenu: () => void;
}

export const useContextMenuStore = create<ContextMenuState>()((set) => ({
  isOpen: false,
  position: { x: 0, y: 0 },
  targetEmail: null,
  selectedEmails: [],

  openMenu: (position, targetEmail, selectedEmails = []) =>
    set({
      isOpen: true,
      position,
      targetEmail,
      selectedEmails: selectedEmails.length > 0 ? selectedEmails : [targetEmail],
    }),

  closeMenu: () =>
    set({
      isOpen: false,
      targetEmail: null,
      selectedEmails: [],
    }),
}));
